import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { QueueHeaderComponent } from "@shared-core/general/queue/layout/queue-header/queue-header.component";

/**
 * Layout shell for unauthenticated / pre-session pages (verify, unauthorized).
 * Renders the brand header on top and a router outlet below — no footer.
 */
@Component({
  selector: "app-guest-layout",
  standalone: true,
  imports: [RouterOutlet, QueueHeaderComponent],
  templateUrl: "./guest-layout.component.html",
  styleUrl: "./guest-layout.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuestLayoutComponent {}
